<template>
  <div id="system-journal-setting-language-alert">
    <ipub-model
      :title="params.id ? 'Edit Language Alert' : 'Add New Language Alert'"
      width="800px"
      :visable="isVisible"
      @confirm="confirm"
      @cancel="cancel"
    >
      <ipub-form
        ref="system-journal-setting-language-form-ref"
        :model="params"
        :rules="rules"
      >
        <ipub-form-item prop="name" label="Language">
          <ipub-input
            placeholder="Enter Language"
            v-model.trim="params.language"
          />
        </ipub-form-item>

        <ipub-form-item prop="languagePack.summary" label="Summary">
          <ipub-input
            placeholder="Enter Summary"
            v-model.trim="params.languagePack.summary"
          />
        </ipub-form-item>

        <ipub-form-item prop="languagePack.keyword" label="Keyword">
          <ipub-input
            placeholder="Enter Keyword"
            v-model.trim="params.languagePack.keyword"
          />
        </ipub-form-item>

        <ipub-form-item prop="languagePack.keywords" label="Keywords">
          <ipub-input
            placeholder="Enter Keywords"
            v-model.trim="params.languagePack.keywords"
          />
        </ipub-form-item>

        <ipub-form-item prop="languagePack.reference" label="Reference">
          <ipub-input
            placeholder="Enter Keyword"
            v-model.trim="params.languagePack.reference"
          />
        </ipub-form-item>

        <ipub-form-item prop="languagePack.references" label="References">
          <ipub-input
            placeholder="Enter Keyword"
            v-model.trim="params.languagePack.references"
          />
        </ipub-form-item>
      </ipub-form>
      <div slot="footer">
        <ipub-button
          plain
          type="primary"
          :style="{ minWidth: '150px' }"
          @click="cancel"
          >Cancel
        </ipub-button>
        <ipub-button
          type="primary"
          :style="{ minWidth: '150px' }"
          @click="confirm()"
          >Save
        </ipub-button>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { settingJournalLanguage } from '@/api/setting'

export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default() {
        return {
          journalId: '',
          language: '',
          languagePack: {
            summary: '',
            keyword: '',
            keywords: '',
            reference: '',
            references: '',
          },
        }
      },
    },
  },
  data() {
    return {
      params: {
        journalId: '',
        language: '',
        languagePack: {
          summary: '',
          keyword: '',
          keywords: '',
          reference: '',
          references: '',
        },
      },
      rules: {},
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      journalId: 'getJournalId',
      publisherId: 'getPublisherId',
    }),
  },
  watch: {
    isVisible(val) {
      if (!val) {
        this.params = {
          journalId: '',
          language: '',
          languagePack: {
            summary: '',
            keyword: '',
            keywords: '',
            reference: '',
            references: '',
          },
        }
      } else {
        if (this.inputData.id) {
          this.getData()
        }
      }
    },
  },
  mounted() {},
  methods: {
    async getData() {
      const languageData = await settingJournalLanguage.query(this.inputData.id)
      if (languageData){
        this.params = {
          ...languageData
        }
      }
    },
    async confirm() {
      if (this.inputData.id) {
        settingJournalLanguage.edit(this.inputData.id,this.params)
          .then(()=>{
            this.$emit('confirm')
            this.$message.success({
              title: 'Success',
              content: 'This Language Alert has been Saved!',
            })
          })
      } else {
        this.params.journalId = this.journalId
        settingJournalLanguage.add(this.params)
          .then(()=>{
            this.$emit('confirm')
            this.$message.success({
              title: 'Success',
              content: 'This Language Alert has been Saved!',
            })
          })
      }
    },
    cancel() {
      this.$emit('cancel')
    },
  },
}
</script>

<style lang="scss" scoped></style>
